import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as segmentFragment } from './segment';
import { api as feeTypeFragment } from './feeType';

export const api = gql`
  fragment Itinerary on Itinerary {
    id
    isFareUpgradeAvailable
    key
    hotelXSellingEnabled
    campaignConfig {
      primeDayConfig {
        isPrimeDayFare
        primeDayFareType
      }
    }
    carbonFootprint {
      isEco
      ecoPercentageThanAverage
      totalCo2Kilos
      totalCo2eKilos
    }
    meRating
    fees {
      price {
        amount
        currency
      }
      type {
        ...FeeTypeInfo
      }
    }
    ticketsLeft
    legs {
      segmentKeys
      segments {
        ...Segment
      }
    }
    transportTypes
    perks {
      primeDiscount {
        amount
        currency
      }
      extraPrimeCoupon {
        amount
        currency
      }
      primeDiscountPerPassenger {
        amount
        currency
      }
      extraPrimeCouponPerPassenger {
        amount
        currency
      }
    }
  }

  ${segmentFragment}
  ${feeTypeFragment}
`;
